import React, { useEffect, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { Breadcrumb, Loader, Nav, Panel } from 'rsuite';
import { BaseErrorModel, BaseResponseModel, PageState } from '@/models/core.model';
import { AxiosError } from 'axios';
import { toastErrorMessage } from '@/utils/toasterMessage';
import { StoryChapterMedia } from '@/models/story-chapter-media.model';
import StoryChapterMediaForm from './story-chapter-media-form';
import { getStoryChapterMedia } from '@/services/story-chapter-media.service';
import PageHeader from '@/components/PageHeader';

const CustomNav = ({ active, onSelect, newMode, ...props }) => {
  return (
    <Nav {...props} activeKey={active} onSelect={onSelect}>
      <Nav.Item eventKey="story-chapter-media-form">Detail</Nav.Item>
    </Nav>
  );
};

const Page = () => {

  const chapterId = useLocation()?.state?.chapterId;
  const requestedTab = useLocation()?.state?.tab;

  const [activeTab, setActiveTab] = useState('story-chapter-media-form');
  const [formObject, setFormObject] = useState<StoryChapterMedia|undefined>(undefined);
  const [loading, setLoading] = useState(false);

  const nav = useNavigate();

  const { id: idParam } = useParams();
  const id = idParam ? parseInt(idParam, 10) : undefined;
  const pageState = id ? PageState.Edit : PageState.New;


  useEffect(() => {
    if (pageState == PageState.Edit) {
      fetchData();
    } else {
      setFormObject(undefined);
    }
    setActiveTab(pre => requestedTab ?? pre);
  }, [id]);
  
  const fetchData = async () => {
    if (id) {
      setLoading(true);
      try {
        const result: BaseResponseModel<StoryChapterMedia> = await getStoryChapterMedia(id);
        if (result.success) {
          setFormObject(result.result);
        }
      } catch (err) {
        const errorModel = (err as AxiosError<BaseErrorModel>).response?.data;
        toastErrorMessage(`Error in fetching Story Chapter Media: ${errorModel?.errorMessage}`);
        nav('stories');
      }
      finally {
        setLoading(false);
      }
    }
  };
 
  return (
    <Panel
      header={
        <PageHeader title={pageState == PageState.Edit && formObject ? `Edit Chapter Media` : 'New Chapter Media'}>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href='/stories'> Stories</Breadcrumb.Item>
            <Breadcrumb.Item href='#' > Chapters</Breadcrumb.Item>
            <Breadcrumb.Item href='#' onClick={ () => 
              chapterId || formObject?.chapterId ? nav(`/stories/chapters/${chapterId || formObject?.chapterId}`, {state:{tab: 'story-chapter-medias'}}) : nav(`stories/chapters`)
            }> Medias</Breadcrumb.Item>
            <Breadcrumb.Item active>{pageState == PageState.Edit ? 'Edit' : 'New'}</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <CustomNav appearance="subtle" active={activeTab} onSelect={key => setActiveTab(key)} newMode={pageState == PageState.New} />
      {
        loading ? <Loader center content="loading ..." /> :
        <>
          {activeTab == 'story-chapter-media-form' && <StoryChapterMediaForm formObject={formObject} pageState={pageState} chapterId={chapterId}/>}
        </>
      }
    </Panel>
  );
};

export default Page;
